import Fetch from "../script/Fetch";
import { TrackedEvent } from "../model/UseEventTrackerTypes";

export default class TrackedEventService {
    static async saveTrackedEvents(events: TrackedEvent[]) {
        const request = await Fetch.doFetch("/trackedevents", {
            method: "POST",
            body: events,
        });

        const result = await request.json();
        if (!request.ok) {
            throw new Error(result.error || "Failed to save event trackers");
        }
    }
}
